import { Pipe } from "@angular/core";
import { Marcacao } from "../marcacao/marcacao-procedimento/marcacao";
import { MoedaFormatadaGenericaPipe } from "./moeda-formatada-generica-pipe";

@Pipe({
    name: 'moedaFormatadaProcedimentoPipe',
    pure: true
})

export class MoedaFormatadaProcedimentoPipe extends MoedaFormatadaGenericaPipe {

    transform(marcacao: Marcacao, currencyCode: string = 'BRL', symbolDisplay: string = 'symbol', digits?: string): string {
        if (marcacao && !marcacao.cobrarProcedimento) {
            return '---';
        }

        return super.transform(marcacao.procedimento.valor, currencyCode, symbolDisplay, digits)
    }
}
